import React from 'react';
import { NudosGenericModal } from 'components/NudosComponents';
import OrdersCancelledModalContent from './OrdersCancelledModalContent/OrdersCancelledModalContent';
import useLockScroll from 'hooks/useLockScroll';

const OrdersCancelledModal = ({ isOpen, onClose, parentQueryParams = '' }: IOrdersCancelledModalProps) => {
  useLockScroll(isOpen);
  if (!isOpen) return null;

  return (
    <NudosGenericModal
      modalContent={
        <OrdersCancelledModalContent
          key={parentQueryParams}
          handleClose={onClose}
          parentQueryParams={parentQueryParams}
        />
      }
      closeModalCallback={onClose}
    />
  );
};

interface IOrdersCancelledModalProps {
  isOpen: boolean;
  onClose: () => void;
  parentQueryParams?: string;
}

export default OrdersCancelledModal;